// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

export async function createDebits(borrowerId:string,releaseObj: Object = {}) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/debits`,
    data: releaseObj,
  }); return response;
}

export async function getDebitsByBorrowers(borrowerId:string, pageNumber: number = 0,pageSize:number = PaginationConst.PAGE_SIZE,  filterObj: Record<string, any> = {}) {
  // Build query parameters
  const params: any = {
    page: pageNumber,
    size: pageSize,
  };
  
  // Add filter parameters if provided
  if (filterObj && typeof filterObj === 'object') {
    Object.keys(filterObj).forEach(key => {
      const value = filterObj[key];
      if (value !== undefined && value !== null && value !== '') {
        params[key] = value;
      }
    });
  }
  
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/debits-insights`,
    params: params,
  }); return response;
}

export async function updateDebitStatus(borrowerId: string, status: string) {
  const response = await HttpClient.PATCH({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits/${borrowerId}/debits`,
    data: { status },
  }); 
  return response;
}

export async function updateIndividualDebitStatus(debitId: string, status: string) {
  const response = await HttpClient.PATCH({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/status`,
    data: { status },
  }); 
  return response;
}

export async function convertDebitToInterest(debitId: string, payload: { interestRate: number; conversionComment?: string }) {
  const response = await HttpClient.PATCH({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/convert-to-interest`,
    data: payload,
  });
  return response;
}

export async function getDebitHistory(debitId: string) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/history`,
  });
  return response.data || response;
}

/**
 * Get all debits across all borrowers with borrower name (admin view)
 * Supports pagination and returns debits ordered by most recent first
 */
export async function getAllDebits(pageNumber: number = 0, pageSize: number = PaginationConst.PAGE_SIZE, filterObj: Record<string, any> = {}) {
  // Build query parameters
  const params: any = {
    page: pageNumber,
    size: pageSize,
    sort: 'createdDate,desc', // Order by created date descending (most recent first)
  };
  
  // Add filter parameters if provided
  if (filterObj && typeof filterObj === 'object') {
    Object.keys(filterObj).forEach(key => {
      const value = filterObj[key];
      if (value !== undefined && value !== null && value !== '') {
        params[key] = value;
      }
    });
  }
  
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits`,
    params: params,
  }); 
  return response.data || response;
}
